import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import axios from 'axios';
import api from '../../config/api';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PublicFooter from '../../components/Layout/PublicFooter';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
import OneSignal from 'react-onesignal';

class HomeScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            sliderImages: [],
            promotionArray: [],
            showPromotion: false,
            categoryArray: [],
            showCategory: false,
            next_page_url: null,
            current_page: 1,
        }
    }

    async componentDidMount() {
        let self = this;
        const user_token = await localStorage.getItem('user_token');
        self.setState({ access_token: user_token });

        if (user_token) {
        }
        self.initializeOneSignal();

        self.getSlider();
        self.getPromotionData();
        setTimeout(() => {
            self.categoryList();
        });
    }

    initializeOneSignal = async () => {
        try {
            await OneSignal.init({
                appId: '9f050115-7c6a-44cf-a71b-afb3709ee7b9',
                // You can add other initialization options here
                notifyButton: {
                    enable: true,
                },
                // Uncomment the below line to run on localhost. See: https://documentation.onesignal.com/docs/local-testing
                // allowLocalhostAsSecureOrigin: true
            });

        } catch (error) {
            console.error("OneSignal initialization error:", error);
        }
    };



    getSlider() {
        var self = this;
        axios({
            method: 'GET',
            url: api.DashboardSlider + "?lang=" + self.state.lang,
        }).then(function (ress) {
            self.setState({ sliderImages: ress.data.message.data })
        }).catch(function (erro) {
        });
    }

    getPromotionData() {
        const self = this;
        axios({
            method: 'GET',
            url: api.PromotionData + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ isLoading: false })
            if (ress.data.error == 200) {
                self.setState({
                    promotionArray: ress.data.message.data,
                    next_page_url: ress.data.message.next_page_url,
                    current_page: ress.data.message.current_page,
                });
            }
            setTimeout(() => {
                self.setState({ showPromotion: true })
            });
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
        });
    }

    getPromotionDataNext(API) {
        const self = this;        
        if (!API) {
            return false;
        }
        axios({
            method: 'GET',
            url: API,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ isLoading: false })
            if (ress.data.error == 200) {
                self.setState({
                    promotionArray: [...self.state.promotionArray, ...ress.data.message.data],
                    next_page_url: ress.data.message.next_page_url,
                    current_page: ress.data.message.current_page,
                });
            }
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
        });
    }

    categoryList() {
        const self = this;
        self.setState({ showCategory: false });
        axios({
            method: 'GET',
            url: api.CategoryList,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            if (ress.data.error == 200) {
                self.setState({
                    isLoading: false,
                    categoryArray: (ress.data && ress.data.message && ress.data.message.category_list && ress.data.message.category_list.data) ? ress.data.message.category_list.data : []
                });
                setTimeout(() => {
                    self.setState({ showCategory: true })
                });
            }
            self.setState({ ProgressBar: false });

        }).catch(function (erro) {
            self.setState({ ProgressBar: false });
            self.setState({ 'isLoading': false });
        });
    }

    render() {
        const responsive = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 480 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 480, min: 0 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            }
        };

        const promotionArraySetting = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 3,
                slidesToSlide: 3 // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 480 },
                items: 3,
                slidesToSlide: 3 // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 480, min: 0 },
                items: 3,
                slidesToSlide: 3 // optional, default to 1.
            }
        };

        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <Header data={{ title: strings["navHome"] }} />



                <div className='home-screen'>
                    <div className='header-promo' style={{ display: "block" }}>
                        <div>
                            <Carousel
                                infinite={true}
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                responsive={responsive}
                                autoPlay
                                key={"001_C1"}
                            >
                                {this.state.sliderImages.map((item, index) =>
                                    <div key={"ITEM_001_" + index} className="banner-wrap">
                                        <img src={item.image_url} className="banner-promo" alt='' />
                                    </div>
                                )}
                            </Carousel>
                        </div>
                    </div>
                    <main className="align-dashs">
                        {this.state.showPromotion ?
                            <div className="section-wrap">
                                <h1>{strings["Promotion"]}</h1>
                                <div className="align-cards promotion-slider">
                                    <Carousel
                                        infinite={false}
                                        centerMode={false}
                                        removeArrowOnDeviceType={["tablet", "mobile"]}
                                        responsive={promotionArraySetting}
                                        containerClass="carousel-container"
                                        key={"002_C2"}
                                        beforeChange={(nextSlide, { currentSlide, onMove }) => {
                                            if ((nextSlide + 3) === this.state.promotionArray.length) {
                                                this.getPromotionDataNext(this.state.next_page_url);
                                            }
                                        }}
                                    >
                                        {this.state.promotionArray.map((item, index) =>
                                            <Link key={"ITEM_002_" + item.id + "_" + index} to={`/promotion/${item.id}?page=${this.state.current_page}`} className="promo-cards">
                                                <p><img src={item.image_url} className="banner-promo" alt='' /></p>
                                                <h2>{item.title}</h2>
                                            </Link>
                                        )}
                                    </Carousel>
                                </div>
                            </div>
                            : null}
                        {this.state.showCategory ?
                            <div className="section-wrap">
                                <h1>{strings["Category"]}</h1>
                                <div className="align-cards promotion-slider">
                                    <Carousel
                                        centerMode={false}
                                        removeArrowOnDeviceType={["tablet", "mobile"]}
                                        responsive={promotionArraySetting}
                                        containerClass="carousel-container"
                                        key={"003_C3"}
                                    >
                                        {this.state.categoryArray.map((item, index) =>
                                            <Link key={"ITEM_003_" + index} to={`/products/${item.slug}`} className="promo-cards">
                                                <p><img src={item.cover_url} className="banner-promo" alt='' /></p>
                                                <h2>{item.name}</h2>
                                            </Link>
                                        )}
                                    </Carousel>
                                </div>
                            </div>
                            : null}
                    </main>
                </div>

                {this.state.access_token ?
                    <Footer />
                    :
                    <PublicFooter />
                }
            </>
        );
    }
}

export default HomeScreen;
